import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { DffSideModule, SpinnerModule } from "@dffedb/ui";

import { SmsServiceRoutingModule } from "./sms-service-routing.module";
import { SmsServiceComponent } from "./sms-service.component";

@NgModule({
    imports: [CommonModule, DffSideModule, SpinnerModule, SmsServiceRoutingModule],
    exports: [],
    declarations: [SmsServiceComponent],
    providers: []
})
export class EForsyningFeaturesSmsServiceModule {}
